export default __webpack_public_path__ + "static/media/helperTextExample.de39cd33.gif";